"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pdfWebservice = void 0;

var _savePdf = require("../utils/savePdf");

var _getParams = _interopRequireDefault(require("./getParams"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var pdfWebservice = function pdfWebservice(settings, method, callbackFunction) {
  var myHeaders = new Headers();
  myHeaders.append("Content-Type", settings.pdfConfigSettings.contentType);
  var bodyParams = (0, _getParams["default"])(settings);
  var endpoint = method === 'send' ? settings.pdfConfigSettings.sendPdfEndpoint : settings.pdfConfigSettings.getPdfEndpoint;
  var requestOptions = {
    method: settings.pdfConfigSettings.method,
    headers: myHeaders,
    body: JSON.stringify(bodyParams),
    responseType: settings.pdfConfigSettings.responseType
  };

  if (method === 'send') {
    fetch(endpoint, requestOptions).then(function (response) {
      return response;
    }).then(function (result) {
      if (callbackFunction) {
        callbackFunction(result);
      }
    })["catch"](function (error) {
      return console.log('error-------', error);
    });
  } else {
    fetch(endpoint, requestOptions).then(function (response) {
      return response.blob();
    }).then(function (result) {
      (0, _savePdf.savePdf)(result, settings.defaultTemplateSettings.pdfName);
    })["catch"](function (error) {
      return console.log('error-------', error);
    });
  }
};

exports.pdfWebservice = pdfWebservice;